import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { StyledEmptyGamesListWrapper } from './styles'
import { CarouselHeader } from '../../atoms/carouselHeader'
import { If } from '../../atoms/if'
import { Text } from '../../atoms/text'
import { game_proptype } from '../../../propTypes'

import { useTranslation } from '../../../context/translationProvider'
import { GameGrid } from '../GameGrid'
import { ResponsiveCSSContainer } from '../../atoms/responsiveContainerCSS'

const GamesList = (props) => {
  const {
    observingValue,
    rows,
    title,
    titleTagType,
    description,
    showAllLink,
    isWide,
    hideText,
    forceLogin,
    games,
    mobileNumOfColumns,
    desktopNumOfColumns,
    headerTrailingElement,
    enableInfiniteScrolling,
    screenName,
    triggerGAEvent,
    categoryName,
  } = props

  const filterGames = () => {
    return games?.filter((game) => !!game && !game?.mock) || []
  }
  const [filteredGames, setFilteredGames] = useState(filterGames())
  const [index, setIndex] = useState(1)
  const { translate } = useTranslation()

  useEffect(() => {
    setFilteredGames(filterGames())
  }, [games])

  useEffect(() => {
    if (index != 1) setIndex(1)
  }, [observingValue])

  return (
    <div>
      <If
        condition={!!title}
        render={() => {
          const props = headerTrailingElement
            ? { customTrailingElement: headerTrailingElement }
            : { href: showAllLink }

          return (
            <CarouselHeader
              title={title}
              titleTag={titleTagType}
              description={description}
              hideDescriptionOnLoggedIn
              {...props}
            />
          )
        }}
      />
      <If
        condition={filteredGames.length > 0}
        render={() => (
          <>
            <ResponsiveCSSContainer showMobile>
              <GameGrid
                rows={rows}
                columns={mobileNumOfColumns}
                games={filteredGames}
                reset={observingValue}
                hideText={hideText}
                isWide={isWide}
                forceLogin={forceLogin}
                enableInfiniteScrolling={enableInfiniteScrolling}
                screenName={screenName}
                triggerGAEvent={triggerGAEvent}
                categoryName={categoryName}
              />
            </ResponsiveCSSContainer>
            <ResponsiveCSSContainer showDesktop>
              <GameGrid
                rows={rows}
                columns={desktopNumOfColumns}
                games={filteredGames}
                reset={observingValue}
                hideText={hideText}
                isWide={isWide}
                forceLogin={forceLogin}
                enableInfiniteScrolling={enableInfiniteScrolling}
                screenName={screenName}
                triggerGAEvent={triggerGAEvent}
                categoryName={categoryName}
              />
            </ResponsiveCSSContainer>
          </>
        )}
        renderElse={() => (
          <StyledEmptyGamesListWrapper>
            <Text>{translate('casino.noGamesAvailable')}</Text>
          </StyledEmptyGamesListWrapper>
        )}
      />
    </div>
  )
}

GamesList.defaultProps = {
  observingValue: null,
  title: null,
  titleTagType: null,
  description: null,
  showAllLink: null,
  rows: 0,
  mobileNumOfColumns: 3,
  desktopNumOfColumns: 6,
  isWide: false,
  showMore: false,
  hideText: false,
  forceLogin: false,
  headerTrailingElement: null,
  games: null,
  enableInfiniteScrolling: false,
}

GamesList.propTypes = {
  observingValue: PropTypes.any,
  title: PropTypes.string,
  titleTagType: PropTypes.string,
  description: PropTypes.string,
  showAllLink: PropTypes.string,
  rows: PropTypes.number,
  mobileNumOfColumns: PropTypes.number,
  desktopNumOfColumns: PropTypes.number,
  isWide: PropTypes.bool,
  showMore: PropTypes.bool,
  hideText: PropTypes.bool,
  forceLogin: PropTypes.bool,
  games: PropTypes.arrayOf(game_proptype),
  headerTrailingElement: PropTypes.func,
  enableInfiniteScrolling: PropTypes.bool,
  screenName: PropTypes.string,
  triggerGAEvent: PropTypes.bool,
  categoryName: PropTypes.string,
}

export { GamesList }
